import "./PatreonButton.scss";

import React from "react";

export default () => (
  <div
    dangerouslySetInnerHTML={{
      __html: `
<a color="primary" class="sc-hMqMXs hNJHmD" tabindex="0" type="button" href="https://www.patreon.com/bePatron?u=18270203" role="button" target="_self"><div display="flex" class="sc-cSHVUG bDCJxk"><div class="sc-ckVGcZ hnTNrw"><span class="sc-dxgOiQ ZmzLr"><svg viewBox="0 0 569 546" xmlns="http://www.w3.org/2000/svg"><g><circle data-fill="1" id="Oval" cx="362.589996" cy="204.589996" r="204.589996"></circle><rect data-fill="2" id="Rectangle" x="0" y="0" width="100" height="545.799988"></rect></g></svg></span></div><div class="sc-hSdWYo gBDeVU"></div><div class="button-text">Become a patron</div></div></a>`,
    }}
  />
);
